/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ExecuteSchedulerByIdRequest} from "../model/execute-scheduler-by-id-request";
import {ListData} from "../model/list-data";
import {Scheduler} from "../model/scheduler";
import {SchedulerEventLogEntry} from "../model/scheduler-event-log-entry";
import {SchedulerView} from "../model/scheduler-view";

@Injectable({
    providedIn: "root",
})
export class SimSchedulerService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public cleanSchedulerEventLogEntries(scheduler: Scheduler) {
        return super.post<boolean>(`/api/Scheduler/CleanSchedulerEventLogEntries`, scheduler);
    }

    public createMissingSchedulers() {
        return super.post<boolean>(`/api/Scheduler/CreateMissingSchedulers`, {});
    }

    public executeScheduler(scheduler: Scheduler) {
        return super.post<boolean>(`/api/Scheduler/ExecuteScheduler`, scheduler);
    }

    public executeSchedulerById(request: ExecuteSchedulerByIdRequest) {
        return super.post<boolean>(`/api/Scheduler/ExecuteSchedulerById`, request);
    }

    public getAvailableSchedulerCount() {
        return super.get<number>(`/api/Scheduler/GetAvailableSchedulerCount`, );
    }

    public getSchedulerById(schedulerId: string) {
        return super.get<Scheduler>(`/api/Scheduler/GetSchedulerById`, {schedulerId: schedulerId});
    }

    public getSchedulerEventLogEntriesByPaging(schedulerId: string, pageIndex: number = 0, pageSize: number = 0) {
        return super.get<ListData<SchedulerEventLogEntry>>(`/api/Scheduler/GetSchedulerEventLogEntriesByPaging`, {schedulerId: schedulerId, pageIndex: pageIndex, pageSize: pageSize});
    }

    public getSchedulers() {
        return super.get<SchedulerView[]>(`/api/Scheduler/GetSchedulers`, );
    }
/**
 * Deletes all schedulers and creates them again
 */ 

    public recreateAllSchedulers() {
        return super.post<boolean>(`/api/Scheduler/RecreateAllSchedulers`, {});
    }

    public toggleScheduler(scheduler: Scheduler) {
        return super.post<boolean>(`/api/Scheduler/ToggleScheduler`, scheduler);
    }

    public upSertScheduler(scheduler: Scheduler) {
        return super.post<boolean>(`/api/Scheduler/UpSertScheduler`, scheduler);
    }
}